import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";
import { devLog } from "../utils/libs";
import axios from "./axiosConfig";

export const setupPushNotifications = () => {

  if (!Capacitor.isNativePlatform()) {
    devLog("Push notifications are not supported on the web.");
    return;
  }

  PushNotifications.requestPermissions().then((result) => {
    if (result.receive === "granted") {
      PushNotifications.register();
    } else {
      devLog("Push Notification permission denied");
    }
  });

  PushNotifications.addListener("registration", (token) => {
    devLog("Push registration success, token: " + token.value);
    // Send the token to your server to store for sending notifications later
    sendTokenToServer(token.value);
  });

  PushNotifications.addListener("registrationError", (error) => {
    devLog("Error on registration: " + JSON.stringify(error));
  });

  PushNotifications.addListener("pushNotificationReceived", (notification) => {
    devLog("Push received: " + JSON.stringify(notification));
  });

  PushNotifications.addListener(
    "pushNotificationActionPerformed",
    (notification) => {
      devLog("Push action performed: " + JSON.stringify(notification));
    }
  );
};

const sendTokenToServer = (token: string) => {
  axios
    .post("/api/v1/notifications/store-token", {
      token: token,
    })
    .then((response) => {
      devLog("Token stored successfully:", response.data);
    })
    .catch((error) => {
      console.error("Error storing token:", error);
    });
};
